export default __webpack_public_path__ + "static/barlow-v4-latin-regular-3bd531230e2e2a412a390b64b3ef6f85.svg";